import { WebPaths } from "../../../../routes/data";
import Colors from "../../../../styles/Colors";
import { loginFailed } from "../../../../utils";
import { IoInformationCircleOutline } from "react-icons/io5";
import { MdOutlineBook } from "react-icons/md";
import { AiOutlineComment } from "react-icons/ai";
import { BsPassport } from "react-icons/bs";
import { TbMessageQuestion } from "react-icons/tb";
// import { RiCustomerService2Fill } from "react-icons/ri";

export interface NavItemsProps {
  label: string;
  url?: string;
  children?: {
    name: JSX.Element;
    subText: string;
    subChildren: {
      label: JSX.Element;
      url: string;
      formType?: string;
    }[];
  }[];
}

const temp = [
  {
    label: "Study Abroad",
    url: WebPaths.Academy,
  },
  {
    label: "Visa Services",
    url: WebPaths.VisaServices,
  },
  {
    label: "FiBi",
    children: [
      {
        name: (
          <div>
            FiBi{" "}
            <span
              style={{
                color: Colors.Blue00,
              }}
            >
              Text
            </span>
          </div>
        ),
        subText: "A text based interview preparation AI",
        subChildren: [
          {
            label: (
              <div>
                Get prepared with <strong>FiBi</strong>
              </div>
            ),
            url: WebPaths.FiBiAi,
            // formType: "",
          },
        ],
      },
      {
        name: (
          <div>
            FiBi{" "}
            <span
              style={{
                color: Colors.Blue00,
              }}
            >
              Voice
            </span>
          </div>
        ),
        subText: "An oral based interview preparation AI",
        subChildren: [
          {
            label: (
              <div>
                Get prepared with FiBi Voice{" "}
                {/* <strong
                  style={{
                    color: Colors.Blue00,
                  }}
                >
                  (Coming soon!)
                </strong> */}
              </div>
            ),
            url: "",
            // url: WebPaths.FiBiVoice,
            formType: "",
          },
        ],
      },
    ],
    // url: WebPaths.FiBiAi,
  },
  {
    label: "About Us",
    url: WebPaths.About,
  },
  {
    label: "FAQs",
    url: WebPaths.FAQs,
  },
  // {
  //   label: "Help",
  //   url: WebPaths.Help,
  // },
  // {
  //   label: "Blogs",
  //   url: "http://blog.seamlessvisa.com",
  // },

  // {
  //   label: "Latest USCIS News",
  //   url: WebPaths.Root,
  // },
];

export const NavItems = (isBusiness: boolean): NavItemsProps[] => {
  const result = [...temp];
  if (isBusiness) {
    result.shift();
  }
  return result;
};

export interface ProfileNavProps {
  label: string;
  url?: string;
  children?: {
    name: JSX.Element;
    onClick?: () => void;
    url?: string;
  }[];
}

export const ProfileNav: ProfileNavProps[] = [
  {
    label: "My Account",
    children: [
      // {
      //   name: <div>Dashboard</div>,
      //   url: WebPaths.Profile,
      // },
      // {
      //   name: (
      //     <div className="flex flex-row items-center gap-2">
      //       <RiCustomerService2Fill /> Chat with support
      //     </div>
      //   ),
      //   // onClick: () => navigate(),
      //   url: `${WebPaths.Help}/?contact=true`,
      // },
      {
        name: <div>Sign Out</div>,
        onClick: loginFailed,
        // url: WebPaths.Auth,
      },
    ],
  },
];

export type NavbarItem = {
  label: string;
  icon?: JSX.Element;
  link: string;
};

export const navItems: NavbarItem[] = [
  {
    label: "Study Abroad",
    icon: <MdOutlineBook className="w-6 h-6" />,
    link: WebPaths.Academy,
  },
  {
    label: "Visa Services",
    icon: <BsPassport className="w-6 h-6" />,
    link: WebPaths.VisaServices,
  },
  {
    label: "FiBi",
    icon: <AiOutlineComment className="w-6 h-6" />,
    // icon: <Sparkles className="w-6 h-6" />,
    link: WebPaths.FiBiAi,
  },
  // {
  //   label: "Blogs",
  //   icon: <RiNewsLine className="w-6 h-6" />,
  //   // link: WebPaths.Blogs,
  //   link: "http://blog.seamlessvisa.com",
  // },
  {
    label: "About",
    icon: <IoInformationCircleOutline className="w-6 h-6" />,
    link: WebPaths.About,
  },
  {
    label: "FAQs",
    icon: <TbMessageQuestion className="w-6 h-6" />,
    link: WebPaths.FAQs,
  },
];

export const getNavItems = (isBusiness: boolean): NavbarItem[] => {
  const result = [...navItems];
  if (isBusiness) {
    // result.shift();
    return [];
  }
  return result;
};
